import React from 'react';
import { useDispatch } from 'react-redux';
import { updateLayout } from '.';

export default function useUpdateLayout() {
  const dispatch = useDispatch();
  return React.useCallback(payload => dispatch(updateLayout(payload)), [dispatch]);
}
